import HomePage from '../../components/pages/HomePage';
import { createBookablePage } from '../_shared/BookablePage';

export default createBookablePage('/', HomePage);
